module.exports = __webpack_public_path__ + "static/media/open_icon.fe97a01b.svg";